module.exports = __webpack_public_path__ + "img/icon_FRUIT.f1fbd516.png";